<template>
	<footer class="main-footer">
		<div class="top-button-container">
			<div class="top-button-wrapper">
				<bi-button
					type="squared-icon"
					@click.stop.prevent="scrollToTop()"
				>
					<i class="icon bis-up" />
				</bi-button>
			</div>
		</div>
		<div class="footer-container">
			<div class="row main-row footer-row">
				<div class="logo-col footer-col">
					<div class="logo-wrap">
						<router-link to="/">
							<img
								:src="cdn + biLogo"
								alt="Bohemia Interactive"
							/>
						</router-link>
						<div class="newsletter-button">
							<span class="newsletter-pre">Subscribe to our</span>
							<bi-button
								type="underline-link"
								@click="openNewsletter"
							>
								Newsletter
							</bi-button>
						</div>
					</div>
					<!-- <div class="social-row">
						<bi-social-buttons />
					</div> -->
				</div>
				<div class="menu-col footer-row">
					<ul class="links-col footer-col right-align subscribe-col">
						<!-- <li>
							<bi-social-buttons />
						</li> -->
						<li class="newsletter-button">
							<span class="newsletter-pre"
								>Never miss another opportunity.</span
							>
							<a
								href="/subscribe"
								target="_parent"
								style="color: black; text-decoration: underline; font-weight: bold; text-underline-offset: 4px;"
							>
								GET NOTIFICATIONS FOR NEW JOB OPENINGS
							</a>
						</li>
					</ul>
					<ul class="links-col footer-col">
						<li>
							<h5 class="footer-heading">
								Bohemia.net
							</h5>
						</li>
						<li v-for="(link, index) in bistudioLinks" :key="index">
							<a
								class="footer-link"
								:href="link.url"
								target="_blank"
								rel="nofollow me noopener noreferrer"
								>{{ link.name }}</a
							>
						</li>
					</ul>
					<ul class="links-col footer-col">
						<li>
							<h5 class="footer-heading">
								Help
							</h5>
						</li>
						<li v-for="(link, index) in helpLinks" :key="index">
							<a
								class="footer-link"
								:href="link.url"
								target="_blank"
								rel="nofollow me noopener noreferrer"
								>{{ link.name }}</a
							>
						</li>
					</ul>
				</div>
			</div>
			<div class="row">
				<div class="policies footer-row">
					<div class="copyright footer-col">
						© {{ new Date().getFullYear() }} Bohemia Interactive
						a.s. Bohemia Interactive® is a registered trademark of
						Bohemia Interactive a.s. All rights reserved.
					</div>
					<div class="legal-links footer-col">
						<ul>
							<li>
								<a
									href="https://www.bohemia.net/cookie-policy"
									target="_blank"
									rel="nofollow me noopener noreferrer"
									>COOKIES</a
								>
							</li>
							<li class="separator">
								|
							</li>
							<li>
								<a
									href="https://www.bohemia.net/privacy-policy"
									target="_blank"
									rel="nofollow me noopener noreferrer"
									>PRIVACY POLICY</a
								>
							</li>
							<li
								class="separator"
								style="opacity: 1; color: #777879;"
							>
								|
							</li>
							<li>
								<a
									href="https://accounts.bistudio.com/terms-and-conditions"
									target="_blank"
									rel="nofollow me noopener noreferrer"
									>TERMS & CONDITIONS</a
								>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<bi-modal-window v-if="isModalOpen" @close="closeModal" />
	</footer>
</template>

<script>
import BiSocialButtons from "./Social-Buttons";
import BiButton from "./Button";
import BiModalWindow from "./Modal-Window";

export default {
	name: "BiFooter",
	components: {
		BiButton,
		BiSocialButtons,
		BiModalWindow
	},
	data() {
		return {
			cdn: "https://static.bistudio.com/bohemia-net/svg/",
			biLogo: "bi_logo.svg",
			isModalOpen: false,
			bistudioLinks: [
				{
					name: "About Us",
					url: "https://www.bohemia.net/company/about"
				},
				{
					name: "Careers",
					url: "https://careers.bohemia.net"
				},
				{
					name: "Store",
					url: "https://store.bohemia.net/"
				},
				{
					name: "Press",
					url: "https://presskits.bohemia.net/"
				},
				{
					name: "Contact",
					url: "https://www.bohemia.net/contact"
				}
			],
			helpLinks: [
				{
					name: "Support",
					url: "https://support.bohemia.net"
				},
				{
					name: "Forums",
					url: "https://forums.bistudio.com"
				},
				{
					name: "Modding",
					url: "https://community.bistudio.com/wiki/Main_Page"
				},
				{
					name: "Licenses",
					url: "https://www.bohemia.net/community/licenses"
				},
				{
					name: "Monetization",
					url: "https://www.bohemia.net/monetization"
				}
			]
		};
	},
	methods: {
		openNewsletter() {
			this.$emit("open-newsletter");
			this.isModalOpen = true;
		},
		closeModal() {
			this.isModalOpen = false;
		},
		scrollToTop() {
			let to = 0;
			let duration = 1050;
			let start = Math.max(
					window.pageYOffset,
					document.documentElement.scrollTop,
					document.body.scrollTop
				),
				change = to - start,
				currentTime = 0,
				increment = 20;
			let easeInOutQuad = function(t, b, c, d) {
				t /= d / 2;
				if (t < 1) return (c / 2) * t * t + b;
				t--;
				return (-c / 2) * (t * (t - 2) - 1) + b;
			};
			let animateScroll = function() {
				currentTime += increment;
				let val = easeInOutQuad(currentTime, start, change, duration);
				document.body.scrollTop = val;
				document.documentElement.scrollTop = val;
				if (currentTime < duration) {
					setTimeout(animateScroll, increment);
				}
			};
			animateScroll();
		}
	}
};
</script>

<style scoped lang="scss" type="text/scss">
@import "../../assets/scss/vars";
@import "../../assets/scss/typography";

.main-footer {
	background: $alabaster;
	padding-top: 81px;
	width: 100%;

	.top-button-container {
		max-width: $sub-nav-container-width;
		margin: auto;
		position: relative;
		padding-right: $footer-container-padding;
		padding-left: $footer-container-padding;
		display: flex;
		justify-content: flex-end;

		.top-button-wrapper {
			position: absolute;
			top: -110px;
		}
	}

	.footer-container {
		max-width: $nav-container-width;
		margin: auto;
		padding-right: $footer-container-padding;
		padding-left: $footer-container-padding;
		position: relative;

		.footer-heading {
			width: 100%;
		}

		.row {
			display: flex;
			align-items: flex-start;
			flex-direction: row;
			width: 100%;
		}

		@media (max-width: $sm) {
			padding-right: 30px;
			padding-left: 30px;
			.footer-row {
				flex-wrap: wrap;
				flex-direction: column;

				.footer-col {
					width: 100%;
					flex: auto;
				}
			}
		}

		.main-row {
			padding-bottom: 34px;
			@media (max-width: $md) {
				flex-wrap: wrap;
			}
		}

		.logo-col {
			flex: 1;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			padding-right: 20px;

			.logo-wrap {
				flex: 1;

				img {
					width: 194px;
				}

				.newsletter-button {
					margin-top: 20px;
					margin-bottom: 20px;
				}

				@media (min-width: $md) {
					.newsletter-button {
						display: none;
					}
				}
				@media (max-width: $sm) {
					.newsletter-button {
						display: none;
					}
				}
			}

			.social-row {
				flex: 1;
				text-align: right;
				padding-top: 30px;
				@media (min-width: $md) {
					display: none;
				}
				@media (max-width: $sm) {
					display: none;
				}
			}
		}

		.menu-col {
			display: flex;
			flex-direction: row;
			justify-content: flex-end;
			width: 100%;
			@media (max-width: $md) {
				justify-content: flex-start;
				.subscribe-col {
					display: none;
				}
			}
			@media (max-width: $sm) {
				justify-content: flex-start;
				.subscribe-col {
					display: block;
				}
			}

			.links-col {
				list-style: none;
				padding-left: 0;
				padding-right: 150px;
				min-width: 150px;

				.newsletter-button {
					margin-top: 8px;

					.newsletter-pre {
						margin-right: 10px;
					}
				}

				&.right-align {
					text-align: right;
					@media (max-width: $md) {
						text-align: left;
					}
				}

				&:first-child {
					padding-right: 112px;
				}

				&:last-child {
					padding-right: 0;
				}

				@media (max-width: $lg) {
					padding-right: 60px;
					min-width: 60px;
					&:first-child {
						padding-right: 50px;
					}
				}
				@media (max-width: $md) {
					padding-top: 20px;
					padding-right: 0;
					margin-right: 80px;
					min-width: 200px;
				}

				li {
					padding-bottom: 11px;

					.footer-link {
						padding-left: 5px;
						padding-right: 5px;
						z-index: 1;
						position: relative;
						font-family: $inter-ui;
						color: $gray;
						font-size: $footer-menu-item-font-size;
						font-weight: $footer-menu-item-font-weight;
						white-space: nowrap;
						text-decoration: none;
						letter-spacing: $footer-menu-item-letter-space;
						transition: color 200ms ease-in;

						&:visited {
							color: $gray;
						}

						&:hover {
							color: $cod-gray;
						}
					}
				}
			}
		}

		.policies {
			border-top: 2px solid $cod-gray;
			padding-top: 32px;
			padding-bottom: 36px;
			width: 100%;
			display: flex;
			flex-direction: row;
			justify-content: space-between;

			.copyright {
				padding-right: 10px;
				font-family: $inter-ui;
				font-size: $footer-copyright-font-size;
				font-weight: $footer-copyright-font-weight;
				letter-spacing: $footer-copyright-letter-space;
				color: $scorpion;
				@media (max-width: $md) {
					text-align: center;
				}
			}

			.legal-links {
				ul {
					display: -webkit-box;
					display: -ms-flexbox;
					display: flex;
					padding-left: 0;
					margin-bottom: 0;
					margin-top: 0;
					list-style: none;
					-webkit-box-orient: horizontal;
					-webkit-box-direction: normal;
					-ms-flex-direction: row;
					flex-direction: row;
					align-items: center;
					@media (max-width: $md) {
						justify-content: center;
						flex-wrap: wrap;
					}

					li {
						a {
							padding-left: 5px;
							padding-right: 5px;
							z-index: 1;
							position: relative;
							font-family: $inter-ui;
							color: $scorpion;
							font-size: $footer-legal-links-font-size;
							font-weight: $footer-legal-links-font-weight;
							text-transform: uppercase;
							white-space: nowrap;
							text-decoration: none;
							letter-spacing: $footer-legal-links-letter-space;

							&:visited {
								color: $scorpion;
							}
						}
					}

					.separator {
						opacity: 1;
						color: #777879;
					}
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/coppiedFooter/Footer.vue